import axios from "axios";

export default {
  namespaced: true,
  state: {
    claims: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    claimsMessage: ''
  },
  mutations: {
    RECEIVED_CLAIMS(state, payload) {
      state.claims = payload;
      state.isReceiving = false;
    },
    RECEIVING_CLAIMS(state) {
      state.isReceiving = true;
    },
    RECEIVING_CLAIM(state) {
      state.isReceiving = true;
    },
    RECEIVED_CLAIM(state, payload) {
      let find = state.claims.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { claims: [payload, ...state.claims] });
      }
      else {
        let index = state.claims.findIndex(x => x._id === payload._id);
        state.claims.splice(index, 1, payload);
      }
    },
    UPDATED_CLAIMS(state, payload) {
      let index = state.claims.findIndex(claim => claim._id === payload._id);
      state = Object.assign(state, {
        claims: state.claims.map((claim, i) => {
          if (i === index) {
            return Object.assign({}, claim, payload);
          }
          return claim;
        }),
        isUpdating: false,
        claimsMessage: 'Claims has been updating!',
      })
    },
    UPDATING_CLAIMS(state) {
      state.isUpdating = true;
    },
    DELETED_CLAIMS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.claims.findIndex(claim => claim._id === payload._id);
      console.log(indexToDelete);
      let claims = [...state.claims];
      claims.splice(indexToDelete, 1);
      state = Object.assign(state, {
        claims: [...claims],
        isDeleting: false,
        idToDelete: null,
        claimsMessage: 'Claim has been Deleted!',
      });
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      console.log(indexToDelete);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_CLAIMS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertClaim({dispatch}, payload) {
      dispatch("receivingClaims");
      console.log("payload", payload)
      let data, headers;
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/claim';
      if(payload.filedata==null || payload.filedata==undefined){
        data = payload;
        headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      }
      else{
        data = new FormData();
        data.append('file', payload.filedata, payload.filename); 
        delete payload['filedata'];
        delete payload['filename'];
        data.append('payload', JSON.stringify(payload));
        headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      }
      let post = {method: "post", url: url, headers: headers, data: data};
      return axios(post)
      .then(response=> {
        let claim = response.data.claim;
        claim.transaction = response.data.transaction;
        dispatch("receiveClaim", claim);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async deleteClaimRequest({dispatch}, payload) {
      dispatch("deletingClaim", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/claim/' + payload._id;
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "delete", url: url, headers: header});
      dispatch("deleteClaim", response.data);
      return response.data;
    },
    async getClaimsRequest({dispatch}) {
      try{
        dispatch("receivingClaims");
        var token = localStorage.getItem('token');
        var url = 'https://api.tradexc.com:3000/get/claims';
        var header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "get", url: url, headers: header});
        dispatch("receiveClaims", response.data);
        return response.data;
      }
      catch(e){return null;}
      
    },
    async findClaimsRequest({dispatch}, payload) {
      try{
        dispatch("receivingClaims", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/claims';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveClaims", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateClaimRequest({dispatch}, payload) {
      dispatch("updatingClaim");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/claim/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: payload,
      };

      axios(post)
      .then((response)=> {
        dispatch("updateClaim", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateClaimStatusRequest({dispatch}, payload) {
      dispatch("updatingClaim");
      let id = payload.claimid;
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/claim/status/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      let response = await axios({method: "put", url: url, headers: headers, data: payload});
      dispatch("updateClaim", response.data);
      return response.data;
    },
    updateClaimImageRequest({dispatch}, payload) {
      dispatch("updatingClaim");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.tradexc.com:3000/update/claim/image/' + id;
      data = new FormData();
      data.append('image', payload.claimimage, payload.imagename); 
      delete payload['claimimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updateClaim", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    receiveClaims({commit}, payload) {
      commit("RECEIVED_CLAIMS", payload)
    },
    receivingClaims({commit}) {
      commit("RECEIVING_CLAIMS")
    },
    receiveClaim({commit}, payload) {
      commit("RECEIVED_CLAIM", payload)
    },
    receivingClaim({commit}) {
      commit("RECEIVING_CLAIMS")
    },
    updateClaim({commit}, payload) {
      commit("UPDATED_CLAIMS", payload)
    },
    updatingClaim({commit}) {
      commit("UPDATING_CLAIMS")
    },
    deleteClaim({commit}, payload) {
      commit("DELETED_CLAIMS", payload)
    },
    deletingClaim({commit}, payload) {
      commit("DELETING_CLAIMS", payload)
    }
  },
};
